module.exports = __webpack_public_path__ + "static/media/digital.f1225b2c.svg";